import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: 1,
  limit: 5,
  filterType: {
    sortBy: "",
  },
};
const filterStockBatchSlice = createSlice({
  name: "filterStockBatch",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setFilter: (state, action) => {
      state.filterType = {
        ...state.filterType,
        ...action.payload,
      };
    },
  },
});

export const { setPage, setLimit, setFilter } = filterStockBatchSlice.actions;
export default filterStockBatchSlice.reducer;
